import { createSelector } from '@ngrx/store';
import { SharedState } from '../shared.reducer';
import { getSharedState } from '@app-shared/store/shared.selectors';

export const queryUserInfo = () => createSelector(getSharedState, (state: SharedState) => state.userInfo);
